module.exports = __webpack_public_path__ + "img/facebook_color.7d67f766.png";